import React, { Component } from 'react';
import { message, Input, InputNumber, Modal, Select, Cascader, Icon, Tooltip, Button, Checkbox } from 'antd';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import './style.less';

class Update extends Component {
    state = {
        params: {},
        loading: false,
        visible: false,
        type: '',
        diseaseList: [],
        productTypeList: [],
        typeList: [],
        secondTypeList: [],
        thirdTypeList: [],
        diseaseModalVisible: false,
        allDiseaseOptions: [],
        selectedForModal: [],
    }

    // 查询访视类型
    queryVisitingType = (record, type) => {
        Fetch.post(API_URL.plan.queryVisitingTypeList, {
        }).then(res => {
            this.setState({ typeList: res.visitingTypeList },()=> {
                type == 'edit' && this.setVisitingTypeData(record, type);
            });
        })
    }

    //设置访视类型初始值
    setVisitingTypeData = (record) => {
        const { firstVisitingTypeId, secondVisitingTypeId } = record;
        const { typeList } = this.state;
        let secondList = [];
        let thirdList = [];
        typeList.map(firstData => {
            if (firstData.childList && firstVisitingTypeId == firstData.visitConfigId) {
                secondList = firstData.childList;
                firstData.childList.map(secondData => {
                    if (secondData.childList && secondVisitingTypeId === secondData.visitConfigId){
                        thirdList = secondData.childList;
                    }
                })
            }
        });
        this.setState({ 
            secondTypeList: secondList,
            thirdTypeList: thirdList,
        });
    }

    show = (record, type) => {
        const { diseaseList = [], productTypeList = []} = record;
        this.setState({
            type,
            params: {
                ...record,
                diseaseName: undefined,
                diseaseId: undefined,
                researchProductTypeName: undefined,
                researchProductTypeId: undefined,
            },
            visible: true,
            diseaseList,
            productTypeList,
            diseaseModalVisible: false,
            allDiseaseOptions: [],
            selectedForModal: [],
        }, () => {
            this.queryVisitingType(record, type);
        });
    }

    hide = () => {
        this.setState({
            params: {},
            loading: false,
            visible: false,
            diseaseModalVisible: false,
            allDiseaseOptions: [],
            selectedForModal: [],
        });
    }

    handleChange = (value, key) => {
        const { params, typeList, secondTypeList } = this.state;
        //清空二级访视和三级访视的数据
        let secondList = [];
        let thirdList = [];
        switch (key) {
            case 'firstVisitingTypeId': {
                params.firstVisitingTypeId = value;
                params.secondVisitingTypeId = undefined;
                params.thirdVisitingTypeId = undefined;
                (typeList || []).map(el => {
                    if (el.visitConfigId == value && !!el.childList) {
                        secondList = el.childList;
                    }
                });
                this.setState({
                    secondTypeList: secondList,
                    thirdTypeList: thirdList,
                })
                break;
            }
            case 'secondVisitingTypeId': {
                params.secondVisitingTypeId = value;
                params.thirdVisitingTypeId = undefined;
                (secondTypeList || []).map(el => {
                    if (el.visitConfigId == value && !!el.childList) {
                        thirdList = el.childList;
                    }
                });
                this.setState({
                    thirdTypeList: thirdList,
                });
                break;
            }
            default: 
                params[key] = value;
                break;
        }
        this.setState({ 
            params,
        });
    }

    handleSearchRetrieveChange = (options, key) => {
        const { params } = this.state;
        const { value, text } = options;
        const oldValue = params[`${key}Id`];
        params[`${key}Id`] = value;
        params[`${key}Name`] = text;
        // 清空疾病名称（项目领域清空或切换时）
        if (key === 'investigationArea' && oldValue !== value) {
            this.setState({ params, diseaseList: [] });
        } else {
            this.setState({ params });
        }
    }

    handleCascaderChange = (value, selectedOptions) => {
        const { params } = this.state;
        params.researchProductTypeId = value;
        params.researchProductTypeName = (selectedOptions || []).map(el => el.label);
        this.setState({ 
            params,
        });
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    confirm = () => {
        const { params, type, diseaseList = [], productTypeList = [], secondTypeList, thirdTypeList } = this.state;
        const {
            lineOfBusinessId,
            investigationAreaId,
            researchProductTypeId,
            visitCategory,
            firstVisitingTypeId,
            secondVisitingTypeId,
            thirdVisitingTypeId,
            visitHour,
        } = params;
        if (!lineOfBusinessId) {
            return message.warning('请选择业务线')
        }
        if (!investigationAreaId) {
            return message.warning('请选择项目领域')
        }
        if (!diseaseList.length) {
            return message.warning('请选择疾病名称')
        }
        if (!(researchProductTypeId || []).length && !productTypeList.length) {
            return message.warning('请选择研究产品类型')
        }
        if (!visitCategory) {
            return message.warning('请输入访视类别')
        }
        if (!firstVisitingTypeId) {
            return message.warning('请选择访视类型')
        }
        if ((secondTypeList || []).length && !secondVisitingTypeId) {
            return message.warning('请选择二级访视类型')
        }
        if ((thirdTypeList || []).length && !thirdVisitingTypeId) {
            return message.warning('请选择三级访视类型')
        }
        if (visitHour !==0 && !visitHour) {
            return message.warning('请输入访视工时')
        }
        //diseaseIds赋值
        params.diseaseIds = diseaseList.map(el => el.diseaseId).join(',');
        //researchProductTypeIds赋值
        if ((researchProductTypeId || []).length && productTypeList.length === 0) {
            params.researchProductTypeIds = researchProductTypeId[researchProductTypeId.length - 1];
        } else {
            params.researchProductTypeIds = productTypeList.map(el => el.researchProductTypeId).join(',');
        }
        this.setState({ loading: true });
        const url = type == 'add' ? API_URL.evaluate.addVisitHour : API_URL.evaluate.editVisitHour;
        Fetch.post(url, {
            ...this.splitParams(params),
            visitingTypeId: thirdVisitingTypeId || secondVisitingTypeId || firstVisitingTypeId,
        }).then(res => {
            message.success(res.success);
            this.hide();
            this.props.loadData();
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    add = (value, id, type) => {
        const { params, diseaseList, productTypeList } = this.state;
        if (type === 'disease') {
            if(!value){
                message.warning('请选择疾病名称')
                return
            }
            params.diseaseName = undefined;
            params.diseaseId = undefined;
            diseaseList.push({diseaseName: value, diseaseId: id});
        } else {
            if(!value){
                message.warning('请选择研究产品类型')
                return
            }
            params.researchProductTypeId = undefined;
            params.researchProductTypeName = undefined;
            const newResearchProductTypeId = id[id.length - 1];
            const newResearchProductTypeName = value.length === 2 ? `${value[0]}-${value[1]}` : value[value.length - 1];
            productTypeList.push({
                researchProductTypeName: newResearchProductTypeName, 
                researchProductTypeId: newResearchProductTypeId,
            });
        }
        this.setState({ 
            params,
            diseaseList,
            productTypeList,
        });
    }

    del = (index, type) => {
        const { diseaseList, productTypeList } = this.state;
        if (type === 'disease') {
            diseaseList.splice(index, 1);
        } else {
            productTypeList.splice(index, 1);
        }
        this.setState({
            diseaseList,
            productTypeList,
        });
    }

    // 打开疾病选择弹窗
    openDiseaseModal = () => {
        const { params } = this.state;
        const { investigationAreaId } = params;
        if (!investigationAreaId) {
            message.warning('请先选择项目领域');
            return;
        }
        this.setState({ loading: true });
        Fetch.post(API_URL.evaluate.queryDiseaseByAreaIdNoPage, {
            needAll: 'TRUE',
            investigationAreaId,
            limit: 99999,
        }).then(res => {
            const { diseaseList } = this.state;
            const list = Array.isArray(res) ? res : (res.list || []);
            this.setState({
                allDiseaseOptions: list,
                loading: false,
                diseaseModalVisible: true,
                selectedForModal: diseaseList.map(item => item.diseaseId),
            });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    // 关闭疾病选择弹窗（取消）
    closeDiseaseModal = () => {
        this.setState({
            diseaseModalVisible: false,
            allDiseaseOptions: [],
            selectedForModal: [],
        });
    }

    // 确认疾病选择
    confirmDiseaseSelection = () => {
        const { allDiseaseOptions, selectedForModal } = this.state;
        if (selectedForModal.length === 0) {
            message.warning('请至少选择一个疾病');
            return;
        }
        const selectedList = allDiseaseOptions
            .filter(item => selectedForModal.includes(item.diseaseId))
            .map(item => ({ diseaseName: item.diseaseName, diseaseId: item.diseaseId }));
        // 如果选择了"所有疾病"，只保留"所有疾病"
        const allDiseaseItem = selectedList.find(item => item.diseaseName === '所有疾病');
        const finalList = allDiseaseItem ? [allDiseaseItem] : selectedList;
        this.setState({
            diseaseList: finalList,
            diseaseModalVisible: false,
            allDiseaseOptions: [],
            selectedForModal: [],
        });
    }

    // 弹窗内：全选/取消全选
    handleSelectAll = (e) => {
        const { allDiseaseOptions } = this.state;
        if (e.target.checked) {
            this.setState({ selectedForModal: allDiseaseOptions.map(item => item.diseaseId) });
        } else {
            this.setState({ selectedForModal: [] });
        }
    }

    // 弹窗内：选择/取消单个疾病
    handleDiseaseCheck = (diseaseId) => {
        const { selectedForModal } = this.state;
        const newSelection = [...selectedForModal];
        const idx = newSelection.indexOf(diseaseId);
        if (idx > -1) {
            newSelection.splice(idx, 1);
        } else {
            newSelection.push(diseaseId);
        }
        this.setState({ selectedForModal: newSelection });
    }

    getDiseaseContent = () => {
        const { diseaseList } = this.state;
        if (!diseaseList || diseaseList.length === 0) return null;
        // 若选择了"所有疾病"，只显示"所有疾病"
        const allDiseaseItem = diseaseList.find(item => item.diseaseName === '所有疾病');
        if (allDiseaseItem) {
            return (
                <div className='form_add_List' key="all">
                    <span className="text" style={{width: '180px'}}>所有疾病</span>
                    <span className='form_del_btn' onClick={() => this.del(0, 'disease')}>
                        <Icon type="minus-circle-o"/>
                    </span>
                </div>
            );
        }
        return (diseaseList || []).map((el, index) => {
            const { diseaseName } = el;
            return(
                <div key={index} className='form_add_List' >
                    <span className="text" style={{width: '180px'}}>{diseaseName}</span>
                    <span className='form_del_btn' onClick={() => this.del(index, 'disease')}>
                        <Icon type="minus-circle-o"/>
                    </span>
                </div>
            );
        });
    }

    getProductTypeContent = () => {
        const { productTypeList } = this.state;
        const result = (productTypeList || []).map((el, index) => {
            const { researchProductTypeName } = el;
            const content = researchProductTypeName;
            return(
                <div key={index} className='form_add_List' >
                    <span className="text" style={{width: '180px'}}>{content}</span>
                    <span className='form_del_btn' onClick={() => this.del(index, 'researchProductType')} >
                        <Icon type="minus-circle-o"/>
                    </span>
                </div>
            );
        })
        return result;
    }

    render() {
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const {
            visible,
            loading,
            type,
            params,
            typeList = [],
            secondTypeList = [],
            thirdTypeList = [],
            diseaseModalVisible,
            allDiseaseOptions,
            selectedForModal,
        } = this.state;
        const { businessList, researchProductTypeList } = this.props;
        const businessOptions = businessList.map(el => <Option key={el.typeConfigureId} value={el.typeConfigureId}>{el.typeValue}</Option>);
        const typeOptions = typeList.map(el => <Option key={el.visitConfigId} value={el.visitConfigId}>{el.configValue}</Option>);
        const secondTypeOptions = secondTypeList.map(el => <Option key={el.visitConfigId} value={el.visitConfigId}>{el.configValue}</Option>);
        const thirdTypeOptions = thirdTypeList.map(el => <Option key={el.visitConfigId} value={el.visitConfigId}>{el.configValue}</Option>);
        const {
            lineOfBusinessId,
            investigationAreaId,
            investigationAreaName,
            researchProductTypeId,
            researchProductTypeName,
            visitCategory,
            visitingTypeId,
            firstVisitingTypeId,
            secondVisitingTypeId,
            thirdVisitingTypeId,
            visitHour,
            regularRemark,
            diseaseSpecificWorkContent,
        } = params;
        return (
            <Modal
                title={`${type == 'add' ? '添加' : '修改'}访视工时`}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                width="520px"
                confirmLoading={loading}
                maskClosable={false}
            >
                <div className="modal-content" style={{ padding: '0 20px' }}>
                <ul className="modal-list">
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '30%' }}>{asterisk}业务线:</div>
                        <div className="item-right" style={{ width: '70%' }}>
                            <Select
                                placeholder='请选择'
                                allowClear
                                style={{ width: 200 }}
                                value={lineOfBusinessId}
                                onChange={value => this.handleChange(value, 'lineOfBusinessId')}
                            >
                                {businessOptions}
                            </Select>
                        </div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '30%' }}>{asterisk}项目领域:</div>
                        <div className="item-right" style={{ width: '70%' }}>
                            <SearchRetrieve
                                keyword='investigationAreaName'
                                style={{ width: 200 }}
                                placeholder="输入名称检索"
                                value={investigationAreaName}
                                params={{ needAll: 'FALSE' }}
                                url={API_URL.evaluate.queryInvestigationAreaListNoPage}
                                config={{ id: 'investigationAreaId', name: 'investigationAreaName' }}
                                onChange={options => this.handleSearchRetrieveChange(options, 'investigationArea')}
                            />
                        </div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '30%' }}>{asterisk}疾病名称:</div>
                        <div className="item-right" style={{ width: '70%' }}>
                            <Button
                                onClick={this.openDiseaseModal}
                                disabled={!investigationAreaId}
                                icon="plus"
                            >
                                选择疾病
                            </Button>
                        </div>
                    </li>

                    <div className='add_list'>{this.getDiseaseContent()}</div>

                    <li className="modal-item">
                        <div className="item-left" style={{ width: '30%' }}>{asterisk}研究产品类型:</div>
                        <div className="item-right" style={{ width: '70%' }}>
                            <Cascader 
                                placeholder='请选择'
                                style={{ width: 200 }}
                                options={researchProductTypeList}
                                value={researchProductTypeId}
                                onChange={(value, selectedOptions) => this.handleCascaderChange(value, selectedOptions)}
                            />
                            <span className='form_add_btn' onClick={() => this.add(researchProductTypeName,researchProductTypeId, 'researchProductType')}>
                                <Icon type="plus-circle-o"/>
                            </span>
                        </div>
                    </li>

                    <div className='add_list'>{this.getProductTypeContent()}</div>

                    <li className="modal-item">
                        <div className="item-left" style={{ width: '30%' }}>{asterisk}访视类别:</div>
                        <div className="item-right" style={{ width: '70%' }}>
                            <Input 
                                placeholder='请输入'
                                style={{ width: 200 }}
                                value={visitCategory}
                                onChange={e => this.handleChange(e.target.value, 'visitCategory')}
                            />
                        </div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '30%' }}>{asterisk}访视类型:</div>
                        <div className="item-right" style={{ width: '70%' }}>
                            <Select
                                placeholder='请选择'
                                allowClear
                                style={{ width: 200 }}
                                value={firstVisitingTypeId}
                                onChange={value => this.handleChange(value, 'firstVisitingTypeId')}
                            >
                                {typeOptions}
                            </Select>
                        </div>
                    </li>
                    {!!secondTypeList.length &&
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '30%' }}>{asterisk}二级访视类型:</div>
                            <div className="item-right" style={{ width: '70%' }}>
                                <Select
                                    placeholder='请选择'
                                    allowClear
                                    style={{ width: 200 }}
                                    value={secondVisitingTypeId}
                                    onChange={value => this.handleChange(value, 'secondVisitingTypeId')}
                                >
                                    {secondTypeOptions}
                                </Select>
                            </div>
                        </li>
                    }
                    {!!thirdTypeList.length &&
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '30%' }}>{asterisk}三级访视类型:</div>
                            <div className="item-right" style={{ width: '70%' }}>
                                <Select
                                    placeholder='请选择'
                                    allowClear
                                    style={{ width: 200 }}
                                    value={thirdVisitingTypeId}
                                    onChange={value => this.handleChange(value, 'thirdVisitingTypeId')}
                                >
                                    {thirdTypeOptions}
                                </Select>
                            </div>
                        </li>
                    }
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '30%' }}>{asterisk}访视工时:</div>
                        <div className="item-right" style={{ width: '70%' }}>
                            <InputNumber
                                placeholder='请输入'
                                style={{ width: 200 }}
                                min={0}
                                precision={2}
                                step={0.01}
                                value={visitHour}
                                onChange={value => this.handleChange(value, 'visitHour')}
                            />
                        </div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '30%' }}>
                            常规备注:
                            <Tooltip title="此次访视通常包含主要内容">
                                <span style={{ color: '#1890ff', marginLeft: 4, cursor: 'pointer' }}>ⓘ</span>
                            </Tooltip>
                        </div>
                        <div className="item-right" style={{ width: '70%' }}>
                            <Input
                                placeholder='请输入'
                                style={{ width: 200 }}
                                value={regularRemark}
                                onChange={e => this.handleChange(e.target.value, 'regularRemark')}
                            />
                        </div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '30%' }}>疾病特有工作内容:</div>
                        <div className="item-right" style={{ width: '70%' }}>
                            <Input
                                placeholder='请输入'
                                style={{ width: 200 }}
                                value={diseaseSpecificWorkContent}
                                onChange={e => this.handleChange(e.target.value, 'diseaseSpecificWorkContent')}
                            />
                        </div>
                    </li>
                </ul>
                </div>
                {/* 疾病选择弹窗 */}
                <Modal
                    title="选择疾病"
                    visible={diseaseModalVisible}
                    onOk={this.confirmDiseaseSelection}
                    onCancel={this.closeDiseaseModal}
                    width={700}
                    bodyStyle={{ maxHeight: 420, overflow: 'auto' }}
                    destroyOnClose
                >
                    <div style={{ marginBottom: 8, borderBottom: '1px solid #e8e8e8', paddingBottom: 8 }}>
                        <Checkbox
                            indeterminate={selectedForModal.length > 0 && selectedForModal.length < allDiseaseOptions.length}
                            checked={allDiseaseOptions.length > 0 && selectedForModal.length === allDiseaseOptions.length}
                            onChange={this.handleSelectAll}
                        >
                            全选
                        </Checkbox>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {allDiseaseOptions.map(item => (
                            <div key={item.diseaseId} style={{ width: 200, padding: '4px 0' }}>
                                <Checkbox
                                    checked={selectedForModal.includes(item.diseaseId)}
                                    onChange={() => this.handleDiseaseCheck(item.diseaseId)}
                                >
                                    {item.diseaseName}
                                </Checkbox>
                            </div>
                        ))}
                        {allDiseaseOptions.length === 0 && (
                            <div style={{ color: '#999', textAlign: 'center', padding: 20, width: '100%' }}>暂无数据</div>
                        )}
                    </div>
                </Modal>
            </Modal>
        );
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitingHours/Update.js